<template>
  <v-container fill-height>
    <v-layout row wrap justify-center>
      <v-flex xs10>
        <Title title="Zusammenfassung" subtitle="Stimmt alles?" />

        <v-card max-width="344" class="mx-auto elevation-4">
          <v-card-title>{{ route.category }} {{ route.id }}</v-card-title>
          <v-card-text>
            <strong>Fahrer/-in:</strong>
            {{ driver.name }}
          </v-card-text>
          <v-card-text>
            <strong>Von:</strong>
            {{ route.from }}
            <br />
            <strong>Nach:</strong>
            {{ route.to }}
          </v-card-text>
        </v-card>

        <div class="mt-8 text-center">
          <v-btn to="/route" color="green" class="mr-5" dark large>Nein</v-btn>
          <v-btn to="/send" color="red" dark large>Ja</v-btn>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Title from "@/components/Title";

export default {
  components: {
    Title
  },
  data: () => ({}),
  computed: {
    route() {
      return this.$store.state.route;
    },
    driver() {
      return this.$store.state.driver;
    }
  }
};
</script>
